
export const SocialMediaTypeMap = {
    FACEBOOK: "1",
    TWITTER: "2",
    LINKEDIN: "3"
}

export const SocialMediaTypeMixin = {
    data() {
        return {
            SocialMediaTypes: SocialMediaTypeMap
        };
    }
}